import { useResendCode } from 'api/auth'
import useCountdown from 'hooks/useCountdown'
import useSnackbar from 'hooks/useSnackbar'
import { Div, Text, TextLink } from 'ui'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as ErrorSVG } from 'assets/icons/snackbar/error.svg'


const ResendCode = ({ mobileNumber }) => {

  const { t } = useTranslation()

  const {
    resendCode,
    isSuccess,
    error
  } = useResendCode()

  const { Snackbar } = useSnackbar('error')
  const countdown = useCountdown()

  const resend = () => resendCode({ mobileNumber })


  useEffect(() => {
    if (isSuccess) countdown.start()
  }, [isSuccess])

  useEffect(() => {
    if (!!error) Snackbar.open({
      icon: ErrorSVG,
      message: error.message
    })
  }, [error])



  if (countdown.isRunning) return (
    <Div display='flex' justifyContent='center'>
      <Text size='xs' weight='medium'>
        {t('resendCode')}
        {' '}
        ({countdown.timeLeft})
      </Text>
    </Div>
  )

  return (
    <Div display='flex' justifyContent='center'>
      <TextLink size='xs' onClick={resend}>
        {t('resendCode')}
      </TextLink>
    </Div>
  )
}

export default ResendCode